import { Link } from "react-router-dom";

import LogoTipo from "~/ui/shared/assets/LogoTipo.png";

import { Plans } from "../planos/plans";
import { Button } from "../shared/button";
import { PageContainer } from "../shared/page-container";

export function Planos() {
  return (
    <PageContainer>
      <main className="h-screen">
      <div className="flex flex-col gap-4 items-center pt-8 mt-4">
          <img src={LogoTipo} alt="Logotipo Pratique Revalida"/>
          <p className="text-surface-foreground-variant text-lg sm:text-xl font-bold text-center">
            Bem vindo à plataforma{" "}
            <span className="text-secondary">Pratique Revalida</span>
          </p>
          <h2 className="text-primary-1 text-2xl sm:text-3xl font-semibold text-center mb-5">
            Niko Takashima
          </h2>
        </div>
        <Plans />

        <Link to="/entrar">
          <Button className="mt-2 w-64 mx-auto shadow-md h-14" variant="default">
            Voltar para tela de login
          </Button>
        </Link>
        <footer className="w-full justify-center items-center leading-3 mt-10">
          <span className="font-normal text-gray-400 text-xs">2024 - Pratique Revalida - Tecnologia para o futuro da medicina - Todos os direitos reservados.</span>
        </footer>
      </main>
    </PageContainer>
  );
}
